(function(){
  'use strict';
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.wire-number-one-slide[data-number-one-page-url]').forEach(function(panel){
      var url=panel.getAttribute('data-number-one-page-url');
      if(!url)return;
      panel.setAttribute('role','link');
      panel.setAttribute('tabindex','0');
      panel.addEventListener('click',function(event){
        if(event.target.closest('a,button,input,select,textarea'))return;
        window.location.href=url;
      });
      panel.addEventListener('keydown',function(event){
        if(event.key==='Enter'||event.key===' '){
          if(event.target.closest('a,button,input,select,textarea'))return;
          event.preventDefault();
          window.location.href=url;
        }
      });
    });
  });
})();
